export default __webpack_public_path__ + "static/media/MACS-FO.2d0e8a19.svg";